<template>
  <div class="customerSummaryAfterSales">
    <div class="customerSummaryAfterSales__title">
      {{ $t('customer.summary.after_sales.title') }}
    </div>
    <div v-if="loading" class="customerSummaryAfterSales__loading">
      <sl-spinner></sl-spinner>
    </div>
    <div v-else-if="error" class="customerSummaryAfterSales__empty">
      {{ $t('customer.summary.load_error') }}
    </div>
    <template v-else>
      <div v-for="group in groups" :key="group.reference" class="customerSummaryAfterSales__row">
        <span class="customerSummaryAfterSales__count">{{ group.count }}</span>
        <span>{{ $t(`afterSales.typeTags.${group.reference}`) }}</span>
      </div>
      <div v-if="claims" class="customerSummaryAfterSales__row">
        <span class="customerSummaryAfterSales__count">{{ claims }}</span>
        <span>{{ $t('customer.summary.after_sales.claims_label') }}</span>
      </div>
      <div
        v-if="!groups.length && !claims && !insurances.length"
        class="customerSummaryAfterSales__empty"
      >
        {{ $t('customer.summary.after_sales.empty') }}
      </div>
      <!-- Policies in force, not cases — hidden entirely when the customer has none, since a
           zero here would read as a claim about coverage rather than an absence of records. -->
      <template v-if="insurances.length">
        <div class="customerSummaryAfterSales__sectionTitle">
          {{ $t('customer.summary.after_sales.insurance_title') }}
        </div>
        <div
          v-for="insurance in insurances"
          :key="insurance.titles.de ?? insurance.titles.en"
          class="customerSummaryAfterSales__row"
        >
          <span class="customerSummaryAfterSales__count">{{ insurance.count }}</span>
          <span>{{ insuranceLabel(insurance) }}</span>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import { useDeviceStore } from '@/stores/device.js'

defineProps({
  groups: {
    type: Array,
    default: () => []
  },
  insurances: {
    type: Array,
    default: () => []
  },
  claims: {
    type: Number,
    default: 0
  },
  loading: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  }
})

const deviceStore = useDeviceStore()

function insuranceLabel(insurance) {
  const titles = insurance.titles ?? {}
  return titles[deviceStore.settings.language] ?? titles.de ?? titles.en
}
</script>

<style scoped>
.customerSummaryAfterSales {
  &__title {
    font-size: var(--sl-font-size-x-small);
    color: var(--sl-color-neutral-500);
    margin-bottom: 8px;
  }

  &__sectionTitle {
    font-size: var(--sl-font-size-x-small);
    color: var(--sl-color-neutral-500);
    margin: 10px 0 6px;
    padding-top: 10px;
    border-top: 1px solid var(--sl-color-neutral-200);
  }

  &__row {
    display: flex;
    align-items: baseline;
    gap: 8px;
    font-size: var(--sl-font-size-small);
    padding: 3px 0;
  }

  &__count {
    min-width: 20px;
    font-weight: var(--sl-font-weight-semibold);
    text-align: right;
  }

  &__empty {
    font-size: var(--sl-font-size-small);
    color: var(--sl-color-neutral-500);
  }

  &__loading {
    display: flex;
    justify-content: center;
    padding: 12px 0;
  }
}
</style>
